"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

var _typeof = require("@babel/runtime/helpers/typeof");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var React = _interopRequireWildcard(require("react"));

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

/**
 * НЕ РЕДАКТИРОВАТЬ
 *
 * Этот файл создан автоматически с помощью svgr
 *
 * Подробнее, как работать с иконками:
 * @see https://lvtv.me/icons
 */
var SvgPlaneSearch = function SvgPlaneSearch(props) {
  return /*#__PURE__*/React.createElement("svg", (0, _extends2["default"])({
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    role: "img"
  }, props), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#plane-search_svg__a)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 7,
    cy: 8,
    r: 5.5,
    stroke: "#17181A"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#17181A",
    d: "m15 15.293-.707.707-3.949-3.949.707-.707zM9.097 6.6a.5.5 0 1 0-.707-.706l.707.707ZM5.049 8.839l-.353-.353-.707.707.353.353.707-.707Zm.396 1.81.353.354.708-.707-.354-.354-.707.707ZM8.39 5.894 4.894 9.39l.707.707L9.097 6.6l-.707-.707ZM5.6 9.39l-.55-.552-.708.707.552.552.707-.707Zm-.706.707.55.551.708-.707-.551-.551-.707.707Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m7.254 7.689.478-.147a.5.5 0 0 0-.338-.333l-.14.48Zm-2.48-1.245-.48-.14-.28.96.48.14.28-.96Zm2.824 4.069.147.478.956-.293-.147-.479-.956.294Zm-.204-3.304-2.62-.765-.28.96 2.62.765.28-.96Zm-.618.626.822 2.678.956-.293-.822-2.678-.956.293Z",
    fill: "#17181A"
  })), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "plane-search_svg__a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h16v16H0z"
  }))));
};

var Memo = /*#__PURE__*/(0, React.memo)(SvgPlaneSearch);
var _default = Memo;
exports["default"] = _default;